import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { messages } from "./messages.i18n";
import { AppHeader } from "@components/app-header";
import MultipleCommunitySelector from "@components/common/multiple-community-selector";
import NoDataFound from "@components/common/no-data-found";
import SearchText from "@components/common/search-text";
import { AddNewRequestButton } from "@components/scan-requests";
import { PATHS } from "@constants/Paths";
import TabsLayout from "@layouts/tabs";
import { PeekBox, PeekGrid, PeekPaper, PeekStack, useTheme } from "@piiqtechnologies/ui-components";
import { RefetchProvider, useCommunities, useDebounce } from "@piiqtechnologies/ui-lib";
export var SCAN_TAB;
(function (SCAN_TAB) {
    SCAN_TAB["UPCOMING_SHOOTS"] = "upcoming-shoots";
    SCAN_TAB["PAST_SHOOTS"] = "past-shoots";
    SCAN_TAB["UNSCHEDULED_REQUESTS"] = "unscheduled-requests";
    SCAN_TAB["REQUESTS"] = "requests";
})(SCAN_TAB || (SCAN_TAB = {}));
export const ScanRequestsLayout = () => {
    var _a;
    const intl = useIntl();
    const theme = useTheme();
    const [searchParams] = useSearchParams();
    const [selectedShoot, setSelectedShoot] = useState(null);
    const [photoshoots, setPhotoshoots] = useState([]);
    const searchCommunityIds = useMemo(() => { var _a; return ((_a = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get("communityIds")) === null || _a === void 0 ? void 0 : _a.split(",")) || []; }, [searchParams === null || searchParams === void 0 ? void 0 : searchParams.get("communityIds")]);
    const [searchKey, setSearchKey] = useState(null);
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [selectedCommunities, setSelectedCommunities] = useState([...searchCommunityIds]);
    const [getCommunities, communities, _communitiesInProgress, communitiesError] = useCommunities();
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(null);
    useEffect(() => {
        getCommunities();
    }, []);
    const handleTabChange = (value) => {
        navigate(value);
    };
    const SCAN_REQUESTS_TABS = [
        {
            value: SCAN_TAB.UPCOMING_SHOOTS,
            label: messages.scanRequestsUpcomingShoots,
        },
        {
            value: SCAN_TAB.PAST_SHOOTS,
            label: messages.scanRequestsTabPastShoots,
        },
        {
            value: SCAN_TAB.UNSCHEDULED_REQUESTS,
            label: messages.scanRequestsTabRequested,
        },
    ];
    useEffect(() => {
        const sgtURLSegments = location.pathname.split("/");
        const activeTabURL = sgtURLSegments.pop() || sgtURLSegments.pop();
        const isValidTabValue = SCAN_REQUESTS_TABS.map(({ value }) => value).includes(activeTabURL);
        setTabValue((isValidTabValue && activeTabURL) || PATHS.SCAN_REQUESTS_UPCOMING_SHOOTS);
    }, [location.pathname]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center", height: theme.spacing(4), width: "100%" },
                React.createElement(AppHeader, { headerLabel: intl.formatMessage(messages.scanRequestsPageTitle) }),
                React.createElement(PeekStack, { flexGrow: 1, direction: "row", width: "100%", height: theme.spacing(3.8), justifyContent: "space-between" },
                    !!communitiesError && React.createElement(NoDataFound, { message: intl.formatMessage(messages.errorMsgCommunity), error: true }),
                    !!((_a = communities === null || communities === void 0 ? void 0 : communities.data) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(MultipleCommunitySelector
                    // TODO: Review PolicyActions
                    , { 
                        // TODO: Review PolicyActions
                        feature: "Analytics" /* PolicyActions.ANALYTICS */, placeholder: !(selectedCommunities === null || selectedCommunities === void 0 ? void 0 : selectedCommunities.length)
                            ? intl.formatMessage(messages.communitySelectorPlaceholder)
                            : intl.formatMessage(messages.communitySelectorPlaceholderAddMore), communities: communities.data, selectedCommunities: selectedCommunities, onSelectionChange: setSelectedCommunities, size: "small" })),
                    React.createElement(AddNewRequestButton, null)))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(PeekBox, { position: "relative" },
                React.createElement(PeekPaper, { sx: {
                        p: theme.spacing(1.5),
                        minHeight: "calc(100vh - 172px)",
                        maxHeight: "calc(100vh - 172px)",
                        overflow: "hidden",
                    } },
                    React.createElement(RefetchProvider, null,
                        React.createElement(TabsLayout, { tabs: SCAN_REQUESTS_TABS, activeTab: tabValue, onTabChange: handleTabChange, TabContent: React.createElement(Outlet, { context: {
                                    selectedCommunities,
                                    searchKey: debouncedSearchKey,
                                    selectedShoot,
                                    setSelectedShoot,
                                    photoshoots,
                                    setPhotoshoots,
                                } }), TabAction: React.createElement(SearchText, { placeholder: tabValue === SCAN_TAB.REQUESTS
                                    ? intl.formatMessage(messages.scanRequestsSearch)
                                    : intl.formatMessage(messages.scanRequestsCompletedSearch), searchText: searchKey, onChange: setSearchKey }) })))))));
};
